import React from 'react';
/**Create a useDebounce Hook for staggering function calls.
 * @param {Function} func A function to call based on a default or specific timeout.
 * @param {Integer} milliseconds An integer value representing a number of milliseconds to debounce the function call by.
 * @returns {Function} A debounced function that calls continuously with a default of 500 milliseconds.
 */
const useDebounce = (func, milliseconds = 800) => {
    const [timerId, setTimerId] = React.useState(null);

    return (event) => {
        if (timerId) {
            clearTimeout(timerId);
            const timeoutId = setTimeout(func, milliseconds, event);
            return setTimerId(timeoutId);
        }
        func();
        const timeoutId = setTimeout(() => {}, milliseconds, event);
        return setTimerId(timeoutId);
    };
};

export default useDebounce;
